/**
 * @generated SignedSource<<d196ba1a4071425f441451f7ac75a909>>
 * @relayHash ea980dc71e017e0ff97547f7399f89eb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 44f469bca26000fb3dc4b1f9bb3f2b26b27b914ca428fdf937e70210d5f6cba9

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ClassificationLevelSource = "CONTENT" | "ORGANIZATION" | "SPACE" | "%future added value";
export type useContentClassificationContentDataClassificationQuery$variables = {
  contentId: string;
  lowerCaseContentStatusArray?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type useContentClassificationContentDataClassificationQuery$data = {
  readonly singleContent: {
    readonly classificationLevelDetails: {
      readonly classificationLevel: {
        readonly color: string | null | undefined;
        readonly description: string | null | undefined;
        readonly guideline: string | null | undefined;
        readonly guidelineADF: string | null | undefined;
        readonly id: string;
        readonly name: string;
        readonly status: string;
      } | null | undefined;
      readonly featureEnabled: boolean;
      readonly isReclassificationPermitted: boolean;
      readonly source: ClassificationLevelSource | null | undefined;
    } | null | undefined;
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type useContentClassificationContentDataClassificationQuery = {
  response: useContentClassificationContentDataClassificationQuery$data;
  variables: useContentClassificationContentDataClassificationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "lowerCaseContentStatusArray"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "status",
        "variableName": "lowerCaseContentStatusArray"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "concreteType": "ClassificationLevelDetails",
        "kind": "LinkedField",
        "name": "classificationLevelDetails",
        "plural": false,
        "selections": [
          {
            "concreteType": "ContentDataClassificationLevel",
            "kind": "LinkedField",
            "name": "classificationLevel",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "name": "guideline"
              },
              {
                "kind": "ScalarField",
                "name": "guidelineADF"
              },
              {
                "kind": "ScalarField",
                "name": "description"
              },
              {
                "kind": "ScalarField",
                "name": "color"
              },
              {
                "kind": "ScalarField",
                "name": "name"
              },
              {
                "kind": "ScalarField",
                "name": "status"
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "featureEnabled"
          },
          {
            "kind": "ScalarField",
            "name": "source"
          },
          {
            "kind": "ScalarField",
            "name": "isReclassificationPermitted"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useContentClassificationContentDataClassificationQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useContentClassificationContentDataClassificationQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "ea980dc71e017e0ff97547f7399f89eb",
    "id": "44f469bca26000fb3dc4b1f9bb3f2b26b27b914ca428fdf937e70210d5f6cba9",
    "metadata": {},
    "name": "useContentClassificationContentDataClassificationQuery",
    "operationKind": "query",
    "text": "query useContentClassificationContentDataClassificationQuery($contentId:ID!,$lowerCaseContentStatusArray:[String]){singleContent(id:$contentId,status:$lowerCaseContentStatusArray){id,classificationLevelDetails{classificationLevel{id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted}}}"
  }
};
})();

(node as any).hash = "9fe8638d2a3bfac914af86e1c977bda9";

export default node;
